import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import { required } from 'redux-form-validators';

import { DefaultButton, ReduxSelectField } from 'common/components';

import { setUserTag } from '../../_redux';

import { staticStyles } from './style';

const TRADING_COMMISSION_TAG_TYPE = 'Trading & Commission';

const TAG_TYPE_OPTIONS = [
  { value: TRADING_COMMISSION_TAG_TYPE, label: TRADING_COMMISSION_TAG_TYPE },
  { value: 'Risk Control', label: 'Risk Control' },
];

const UserAddTagForm = ({
  id,
  tags,
  withTypeFilter,
  fixedType,
  selectedType,
  change,
  handleSubmit,
  pristine,
  submitting,
  invalid,
  dispatch,
  error,
  submitTags,
}) => {
  const submit = handleSubmit(values =>
    submitTags ? submitTags(values.tags) : setUserTag({ tags: values.tags, id }, dispatch)
  );

  const withType = withTypeFilter || !!fixedType;
  const typeFilter = fixedType || selectedType;
  const visibleTags = withType ? tags.filter(tag => tag.type === typeFilter) : tags;

  return (
    <form className="UserAddTagForm" onSubmit={submit}>
      <div className="UserAddTagForm__inputs-inner">
        {withType && (
          <Field
            component={ReduxSelectField}
            name="type"
            maxMenuHeight={100}
            textId="justType"
            options={TAG_TYPE_OPTIONS}
            validate={[required()]}
            disabled={submitting || !!fixedType}
            onChange={() => change('tags', [])}
          />
        )}
        <Field
          component={ReduxSelectField}
          name="tags"
          maxMenuHeight={100}
          textId="justTag"
          options={visibleTags.map(tag => ({ value: tag.id, label: `${tag.name} (${tag.description})` }))}
          validate={[required()]}
          disabled={submitting}
          searchable
          multi
        />
      </div>
      <DefaultButton
        textId="justAdd"
        type="submit"
        loading={submitting}
        disabled={invalid || pristine || submitting}
        filled
      />
      {error && <strong className="formError">{error}</strong>}

      <style jsx>{staticStyles}</style>
    </form>
  );
};

UserAddTagForm.propTypes = {
  id: PropTypes.number.isRequired,
  tags: PropTypes.array.isRequired,
  withTypeFilter: PropTypes.bool,
  fixedType: PropTypes.string,
  selectedType: PropTypes.string,
  change: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  pristine: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  submitting: PropTypes.bool.isRequired,
  dispatch: PropTypes.func.isRequired,
  error: PropTypes.string,
  submitTags: PropTypes.func,
};

UserAddTagForm.defaultProps = {
  withTypeFilter: false,
  fixedType: null,
  selectedType: undefined,
  error: '',
  submitTags: null,
};

const selector = formValueSelector('user-add-tag-form');

export default connect(state => ({ selectedType: selector(state, 'type') }))(
  reduxForm({
    form: 'user-add-tag-form',
    destroyOnUnmount: true,
  })(UserAddTagForm)
);
export { UserAddTagForm };
